import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {}
        },
    },
    getters: {
        items: state => state.items,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('admin/oauth/clients', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('admin/oauth/clients', payload);

            return response;
        },
        async update({ commit }, payload) {
            const response = await http.patch(`admin/oauth/clients/${payload.id}`, payload);

            return response;
        },
        async deactivate({ commit }, id) {
            const response = await http.patch(`admin/oauth/clients/${id}/deactivate`);

            return response;
        },
        async activate({ commit }, id) {
            const response = await http.patch(`admin/oauth/clients/${id}/activate`);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`admin/oauth/clients/${id}`);

            return response;
        },
        async resetSecret({ commit }, id) {
            const response = await http.patch(`admin/oauth/clients/${id}/reset-secret`);

            return response;
        }
    }
}